module.exports = {
  domain: 'mere-archive.netlify.com',
};
